import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import combineReducer from './combineReducers';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['authReducer'],
  blacklist: [
    'SignupStepPageReducer',
    'roleReducer',
    'commonReducer',
    'serviceReducer',
    'signupReducer',
    'followReducer',
    'todayAppointmentReducer',
    'patientListReducer'
  ]
};
const persistedReducer = persistReducer(persistConfig, combineReducer);
const store = configureStore({
  reducer: persistedReducer
});
export const persistor = persistStore(store);
export default store;
